import { object, string } from "yup";

import { emailValidationSchema } from "utils/yup/emailValidationSchema";
import { validationMessages } from "utils/yup/validationMessages";

export const loginFormValidationSchema = object().shape({
  email: emailValidationSchema.required(validationMessages.requiredField),
  password: string().required(validationMessages.requiredField),
});
